export default {"src":"/_next/static/media/fadersHorizontal_24.feb86fe6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};